// react and js
import { React, useState, useMemo, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import Routing from "./routes";

// mui

// components

// hooks
import appContext from "./hooks/appContext";
import { stateStorageInit } from "./hooks/stateStorageInit";
import useAffiliateTracking from "./hooks/useAffiliateTracking";

// i18n
import i18n from "./i18n";

// layouts

// pages

// theme
import ThemeProvider from "./theme/ThemeProvider";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function App() {
  // Important to surpress chrome preload warnings
  useEffect(() => {
    const preLoadWarningSurpress1 = new Image();
    preLoadWarningSurpress1.src = "/logo/logo-512.png";

    const preLoadWarningSurpress2 = new Image();
    preLoadWarningSurpress2.src = "/icon/icon-192-192.png";

    const preLoadWarningSurpress3 = new Image();
    preLoadWarningSurpress3.src = "/icon/icon-256-256.png";

    const preLoadWarningSurpress4 = new Image();
    preLoadWarningSurpress4.src = "/icon/icon-512-512.png";

    const preLoadWarningSurpressP1 = new Image();
    preLoadWarningSurpressP1.src = "/illustrations/partners/partners-logo-ic-markets.png";

    const preLoadWarningSurpressP2 = new Image();
    preLoadWarningSurpressP2.src = "/illustrations/partners/partners-logo-ic-trading.png";

    const preLoadWarningSurpressP3 = new Image();
    preLoadWarningSurpressP3.src = "/illustrations/partners/partners-logo-admiral-markets.png";

    const preLoadWarningSurpressP4 = new Image();
    preLoadWarningSurpressP4.src = "/illustrations/partners/partners-logo-vantage.png";

    const preLoadWarningSurpressP5 = new Image();
    preLoadWarningSurpressP5.src = "/illustrations/partners/partners-logo-blackbull-markets.png";

    const preLoadWarningSurpressP6 = new Image();
    preLoadWarningSurpressP6.src = "/illustrations/partners/partners-logo-moneta-markets.png";

    const preLoadWarningSurpressP7 = new Image();
    preLoadWarningSurpressP7.src = "/illustrations/partners/partners-logo-robo-forex.png";

    const preLoadWarningSurpressP8 = new Image();
    preLoadWarningSurpressP8.src = "/illustrations/partners/partners-logo-pu-prime.png";

    const preLoadTest = new Image();
    preLoadTest.src = `/fonts/open-sans-v35-latin-300.woff2`;
  }, []);

  const [stateStorage, setStateStorage] = useState(stateStorageInit);

  const myContext = useMemo(
    () => ({ stateStorage, setStateStorage }),
    [stateStorage, setStateStorage]
  );

  // Affiliate tracking
  useAffiliateTracking();
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ThemeProvider>
          <appContext.Provider value={myContext}>
            <DocumentDirection />
            <Routing />
          </appContext.Provider>
        </ThemeProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

// Side-effect component: sync <html lang="..."> with the active language and
// keep the document direction LTR for every locale. We deliberately do NOT
// flip <html dir> for Arabic — mirroring the whole layout (stepper order, logo
// side, scrollbar position, MUI margin/padding logical props) looks wrong
// here. The browser's Unicode BiDi algorithm renders Arabic text correctly
// inside individual text containers without any document-level flip.
function DocumentDirection() {
  const { i18n: i18nInstance } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18nInstance.language || "en";
    document.documentElement.dir = "ltr";
  }, [i18nInstance.language]);
  return null;
}
